import React, { useCallback, useEffect, useState } from 'react';

interface Spark {
  id: number;
  x: number;
  y: number;
  size: number;
}

export function SharedEffects() {
  const [sparks, setSparks] = useState<Spark[]>([]);

  const createSpark = useCallback(() => {
    const spark: Spark = {
      id: Date.now() + Math.random(),
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
    };
    setSparks((prev) => [...prev.slice(-6), spark]);
    setTimeout(() => {
      setSparks((prev) => prev.filter((s) => s.id !== spark.id));
    }, 800);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() > 0.4) createSpark();
    }, 1300);
    return () => clearInterval(interval);
  }, [createSpark]);

  return (
    <>
      {sparks.map((spark) => (
        <div
          key={spark.id}
          className="spark-flash"
          style={{ position: 'absolute', left: `${spark.x}%`, top: `${spark.y}%` }}
        >
          <div
            style={{
              width: spark.size * 2,
              height: spark.size * 2,
              borderRadius: '50%',
              backgroundColor: '#4285F4',
              boxShadow: `0 0 ${spark.size * 6}px ${spark.size * 2}px rgba(66,133,244,0.6), 0 0 ${spark.size * 12}px ${spark.size * 4}px rgba(66,133,244,0.2)`,
            }}
          />
        </div>
      ))}

      {[...Array(5)].map((_, i) => (
        <div
          key={`particle-${i}`}
          className="particle-float"
          style={{
            position: 'absolute',
            borderRadius: '50%',
            width: 2,
            height: 2,
            backgroundColor: '#4285F4',
            opacity: 0.3,
            left: `${15 + i * 18}%`,
            top: `${20 + (i % 3) * 25}%`,
            animationDelay: `${i * 1.5}s`,
            animationDuration: `${6 + i * 1.2}s`,
          }}
        />
      ))}
    </>
  );
}
